module.exports = __webpack_public_path__ + "static/media/Operations Research.ca4d1441.pdf";


//////////////////
// WEBPACK FOOTER
// ./src/assets/MECH/Operations Research.pdf
// module id = 144
// module chunks = 0